import BlockCategoryCarouselItem from './BlockCategoryCarouselItem';
export default BlockCategoryCarouselItem;
